import { Metric } from '../constants';
import { CompletedRoutesInsightsDriverBreakdownOvertimePaginatedQuery } from '../../queries/insights/RoutesBreakdownByDriverOverTime';

export const getMetricQuery = (metric: Metric | undefined): string => {

  switch (metric) {
    case Metric.COMPLETED_ROUTES:
      return CompletedRoutesInsightsDriverBreakdownOvertimePaginatedQuery({
        completedRoutes: true,
      });
    case Metric.COMPLETED_ORDERS:
      return CompletedRoutesInsightsDriverBreakdownOvertimePaginatedQuery({
        completedOrders: true,
      });
    case Metric.ESTIMATED_DISTANCE:
      return CompletedRoutesInsightsDriverBreakdownOvertimePaginatedQuery({
        estimatedDistanceCompleted: true,
      });
    case Metric.WORKING_TIME:
      return CompletedRoutesInsightsDriverBreakdownOvertimePaginatedQuery({
        completedWorkingTime: true,
      });
    default:
      return CompletedRoutesInsightsDriverBreakdownOvertimePaginatedQuery({
        completedRoutes: true,
        completedOrders: true,
        estimatedDistanceCompleted: true,
        completedWorkingTime: true,
      });
  }
};
